import React, { useEffect, useState } from 'react';
import Layout from '../../components/common/pageLayout';
import Form from '../../components/GuarantyClaims/form';
import constant from '../../constant';
import { toast } from 'react-toastify';
import { v3_add_document } from '../../actions/v3/document';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { v3_add_claim, v3_assign_claim } from '../../actions/v3/guaranteeClaims';
import AssignUser from '../../components/GuarantyClaims/assignUser';

const AddDocument = (props) => {

    const location = useLocation();
    const { data: encodedData } = location.state || {};
    const [loading, setLoading] = useState(false);

    const [claimId, setClaimId] = useState(null)
    const onSubmit = (model) => {
        v3_add_claim(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message);


                setClaimId(res.result.claimId)



            } else {
                toast.error(res.error);
            }
        });
    };

    const onSaveAssignee = async (assignedUsers) => {
        if (!assignedUsers.length) {
            toast.warning('Please select at least one user.');
            return;
        }

        setLoading(true);

        try {
            const res = await v3_assign_claim({
                claimId,
                users: assignedUsers,
            });

            if (res.status) {
                toast.success(res.result?.message || 'Users assigned successfully');
                props.history.push(constant.Authedcomponent.shipGuarantyClaims.url, {
                    data: encodedData
                });
            } else {
                toast.error(res.error || res?.error?.message || 'Assignment failed');
            }
        } catch (err) {
            toast.error('Something went wrong while assigning users.');
        } finally {
            setLoading(false);
        }
    };


    return (
        <React.Fragment>
            <Layout title="Create Claim">
                {!claimId && <Form
                    projectId={JSON.parse(atob(encodedData))['PROJECT_ID']}
                    title="Add Claim"
                    onSubmit={onSubmit}
                    buttonName="Create Claim"
                />}

                {claimId && <AssignUser
                    loading={loading}
                    setLoading={setLoading}
                    claimId={claimId}
                    onSaveAssignee={onSaveAssignee}
                />}
            </Layout>
        </React.Fragment>
    );
};

export default AddDocument;
